// @ts-nocheck
import { Button, Form } from "react-bootstrap";
import "./ExtractActions.css";
import { useState } from "react";
import NotificationToast from "../../../../../components/NotificationToast/NotificationToast";

export interface ExtractActionsProps {
  onFinalizar?: () => Promise<{ show?: boolean; message?: string; type?: string; reload?: boolean } | void> | void;
  onSalvar?: () => Promise<{ show?: boolean; message?: string; type?: string; reload?: boolean } | void> | void;
  onVisualizar?: () => void | Promise<void>;
  showFinalizar?: boolean;
  showSalvar?: boolean;
  showEligibilityCheck?: boolean;
  apto?: boolean;
  idResposta?: string | null;
  idSindicato?: string | null;
}

const ExtractActions = ({
  onFinalizar,
  onSalvar,
  showFinalizar = true,
  showSalvar = true,
  showEligibilityCheck = false,
  apto = false,
  idResposta = null,
  idSindicato = null,
}: ExtractActionsProps) => {
  const [toastData, setToastData] = useState<{
    show: boolean;
    message: string;
    type: string;
  }>({
    show: false,
    message: "",
    type: "",
  });

  const handleSave = async () => {
    if (!onSalvar) return;
    const toastResponse = await onSalvar();

    if (toastResponse?.show) {
      setToastData((prev) => ({
        ...prev,
        show: true,
        message: toastResponse?.message ?? prev.message,
        type: toastResponse?.type ?? prev.type,
      }));
      if (toastResponse?.reload) {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    }
  };

  const handleFinalizar = async () => {
    if (!onFinalizar) return;
    const toastResponse = await onFinalizar();

    if (toastResponse?.show) {
      setToastData((prev) => ({
        ...prev,
        show: true,
        message: toastResponse?.message ?? prev.message,
        type: toastResponse?.type ?? prev.type,
      }));
    }
  };

  return (
    <>
      <div
        className={`analysis-actions-footer d-flex align-items-center mt-4 ${
          showEligibilityCheck
            ? "justify-content-between"
            : "justify-content-end"
        }`}
      >
        {showEligibilityCheck && (
          <Form.Check
            type="switch"
            id="switch-apto"
            label="Apto a participar do Programa Meritocracia"
            checked={apto}
            disabled
          />
        )}
        <div className="save-submit-buttons d-flex gap-2">
          {showSalvar && (
            <Button variant="primary" onClick={handleSave} className="save-btn">
              SALVAR
            </Button>
          )}

          {showFinalizar && (
            <Button
              variant="success"
              onClick={handleFinalizar}
              className="sucess-btn"
            >
              GERAR EXTRATO
            </Button>
          )}
        </div>
      </div>

      <NotificationToast
        show={toastData.show}
        onClose={() => setToastData((prev) => ({ ...prev, show: false }))}
        message={toastData.message}
        type={toastData.type}
      />
    </>
  );
};

export default ExtractActions;
